import React, {Component} from 'react'
import PropTypes from 'prop-types'
import BatchItem from "./BatchItem"

class BatchList extends Component {
    render() {
        const {orders, reloadItems, statusBatch} = this.props

        return orders.map(order => <BatchItem key={order._id} order={order} reloadItems={reloadItems} statusBatch={statusBatch}/>)
    }
}

BatchList.propTypes = {
    orders: PropTypes.array.isRequired
}

export default BatchList